module.exports = __webpack_public_path__ + "img/upload.e6e002d1.gif";